import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "global-container" }
const _hoisted_3 = { style: {
                display: 'flex',
                flexDirection: 'column',
        } }
const _hoisted_4 = { class: "text-h6 pa-2" }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_6 = { class: "text-h6 pa-2" }
const _hoisted_7 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_8 = {
  class: "text-caption",
  style: { verticalAlign: "middle", justifyContent: "center" }
}
const _hoisted_9 = { class: "text-h6 pa-2" }
const _hoisted_10 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_11 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%"} }
const _hoisted_12 = { class: "text-h6 pa-2" }
const _hoisted_13 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","width":"100%"} }
const _hoisted_15 = {
  class: "rounded-xl pa-2",
  style: {"max-width":"70%","word-break":"break-word","white-space":"pre-wrap","backdrop-filter":"blur(5px)"}
}

import HeaderComponent from '@/components/home/HeaderComponent.vue'
import { deleteDoc, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore'
import { deleteObject, ref as storageRef, uploadBytes } from 'firebase/storage'
import { updatePassword, createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, validatePassword } from 'firebase/auth'
import { ref, watch } from 'vue'
import { firestore as db, storage, auth } from '@/main'


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const newPassword = ref('')
const confirmPassword = ref('')

const email = ref('')
const passwordToCreate = ref('')
const confirmPasswordToCreate = ref('')
const uidToCreate = ref('')

const adminEmail = ref('')
const adminPassword = ref('')

const loadingItem = ref('')
const isLoggingIn = ref(false)

const isAdmin = ref(false)
const showUserTypeDescriptionWindow = ref(false)
const featuresByUserType = ref([
  {
    feature: 'Read Posts (Awards, News, Gallery)',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Members',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Lectures',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Publications',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Contact',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Downloads (Public only)',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Research/Projects',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Banners, Homescreen',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'Withdraw / Update Password',
    admin: true,
    standard: true,
    guest: true
  },
  {
    feature: 'View Private Downloads',
    admin: true,
    standard: true,
    guest: false
  },
  {
    feature: 'Create/Modify/Delete Posts (Awards, News, Gallery)',
    admin: true,
    standard: false,
    guest: false
  },
  {
    feature: 'Create/Modify/Delete Members',
    admin: true,
    standard: false,
    guest: false
  },
  {
    feature: 'Update Lectures',
    admin: true,
    standard: false,
    guest: false
  },
  {
    feature: 'Add/Update/Delete Publications',
    admin: true,
    standard: false,
    guest: false
  },
  {
    feature: 'Update Contact',
    admin: true,
    standard: false,
    guest: false
  },
  {
    feature: 'Create/Update/Delete Downloads and Private Downloads',
    admin: true,
    standard: false,
    guest: false
  },
  {
    feature: 'Update Research/Projects',
    admin: true,
    standard: false,
    guest: false
  },
  {
    feature: 'Update Site Settings (Banner, Create Accounts)',
    admin: true,
    standard: false,
    guest: false
  }
])

const isValidPassword = ref(false)
const isValidPasswordToCreate = ref(false)

const panel = ref<number[] | number>([0])
const bannerType = ref('Video')
const selectedBanner = ref<File|null>(null)

const showSignInDialog = ref(false)

function changePassword () {
  loadingItem.value = 'changePassword'

  if (auth.currentUser != null) {
    updatePassword(auth.currentUser, newPassword.value).then(() => {
      alert('Password updated successfully.')
      newPassword.value = ''
      confirmPassword.value = ''
    }).catch((e: Error) => {
      alert(`An error occured while updating the password: ${e.message}`)
    }).finally(() => {
      loadingItem.value = ''
    })
  } else {
    alert('No user is currently signed in.')
    loadingItem.value = ''
  }
}

function createUser () {
  loadingItem.value = 'createUser'

  createUserWithEmailAndPassword(auth, email.value, passwordToCreate.value).then((userCredential) => {
    uidToCreate.value = userCredential.user.uid
    alert('User created successfully.\nSwitched to the new user.')
    email.value = ''
    passwordToCreate.value = ''
    confirmPasswordToCreate.value = ''
    loadingItem.value = isAdmin.value ? 'createUser' : ''

    if (isAdmin.value) {
      showSignInDialog.value = true
    }
  }).catch((e: Error) => {
    alert(`An error occured while creating the user: ${e.message}`)
    loadingItem.value = ''
  })
}

function signIn () {
  isLoggingIn.value = true

  signInWithEmailAndPassword(auth, adminEmail.value, adminPassword.value)
    .then(() => {
      getDoc(doc(db, 'Users', auth.currentUser!.uid)).then((docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data()
          if (!data.isAdmin) {
            alert('The account you signed in with does not have administrator rights.')
          } else {
            grantAdminRights()
          }
        } else {
          alert('The account you signed in with does not have administrator rights.')
        }
      }).catch((e: Error) => {
        alert(`An error occured while verifying admin rights: ${e.message}`)
        isLoggingIn.value = false
      }).finally(() => {
        adminEmail.value = ''
        adminPassword.value = ''
        isLoggingIn.value = false
      })
    })
    .catch((e: Error) => {
      alert(`An error occured while signing in: ${e.message}`)
      isLoggingIn.value = false
    })
}

function grantAdminRights () {
  setDoc(doc(db, 'Users', uidToCreate.value), {
    isAdmin: isAdmin.value
  }).then(() => {
    alert('User privileges have been elevated.')
    email.value = ''
    passwordToCreate.value = ''
    confirmPasswordToCreate.value = ''
    isAdmin.value = false
    adminEmail.value = ''
    adminPassword.value = ''
    uidToCreate.value = ''
    isLoggingIn.value = false
    showSignInDialog.value = false
  }).catch((e: Error) => {
    alert(`An error occured while creating the user document: ${e.message}`)
  }).finally(() => {
    loadingItem.value = ''
  })
}

function closeSignInDialog () {
  if (confirm('If you close this window, the user you just created will have standard user rights, not administrator rights.\nDo you want to continue?')) {
    showSignInDialog.value = false
  }
}

function withdraw () {
  if (auth.currentUser != null) {
    if (confirm('Are you sure you want to withdraw?\nThis action cannot be undone.')) {
      loadingItem.value = 'withdraw'
      const uid = auth.currentUser.uid

      getDoc(doc(db, 'Users', uid)).then((docSnap) => {
        if (docSnap.exists()) {
          deleteDoc(doc(db, 'Users', uid)).catch((e: Error) => {
            alert(`An error occured while deleting the user document: ${e.message}`)
          })
        }
      }).finally(() => {
        auth.currentUser!.delete().then(() => {
          alert('Your account has been withdrawn successfully.')
          loadingItem.value = ''
        }).catch((e: Error) => {
          alert(`An error occured while withdrawing the account: ${e.message}`)
          loadingItem.value = ''
        })
      })
    }
  } else {
    alert('No user is currently signed in.')
  }
}

function changeBanner () {
  if (selectedBanner.value === null) {
    alert('Please select a file first.')
  } else {
    loadingItem.value = 'banner'
    getDoc(doc(db, 'Banner', 'Contents'))
      .then((d) => {
        if (d.exists()) {
          const data = d.data()
          if (data.fileName !== undefined && data.fileName !== '') {
            const previousFileRef = storageRef(storage, `banner/${data.fileName}`)

            deleteObject(previousFileRef).catch((e: Error) => {
              console.log(`An error occured while deleting the previous banner file: ${e.message}`)
            }).then(() => {
              updateDoc(doc(db, 'Banner', 'Contents'), {
                type: bannerType.value,
                fileName: selectedBanner.value?.name
              }).then(() => {
                const data = storageRef(storage, `banner/${selectedBanner.value?.name}`)

                uploadBytes(data, selectedBanner.value!).then(() => {
                  alert('Banner updated successfully.')
                  selectedBanner.value = null
                }).catch((e: Error) => {
                  alert(`An error occured while uploading the file: ${e.message}`)
                }).finally(() => {
                  loadingItem.value = ''
                })
              }).catch((e: Error) => {
                alert(`An error occured while updating the document: ${e.message}`)
                loadingItem.value = ''
              })
            })
          }
        }
      })
  }
}

onkeyup = (e: KeyboardEvent) => {
  if (e.key === 'Enter' && showSignInDialog.value && (adminEmail.value !== '' && adminPassword.value !== '')) {
    signIn()
  } else if (e.key === 'Enter' && !showSignInDialog.value && newPassword.value === confirmPassword.value && isValidPassword.value && (panel.value === 0 || panel.value[0] === 0)) {
    changePassword()
  } else if (e.key === 'Enter' && !showSignInDialog.value && email.value.includes('@') && passwordToCreate.value === confirmPasswordToCreate.value && isValidPasswordToCreate.value && panel.value === 1) {
    createUser()
  }
}

watch(newPassword, () => {
  validatePassword(auth, newPassword.value)
    .then(status => {
      isValidPassword.value = status.isValid
    })
})

watch(passwordToCreate, () => {
  validatePassword(auth, passwordToCreate.value)
    .then(status => {
      isValidPasswordToCreate.value = status.isValid
    })
})

watch(bannerType, () => {
  selectedBanner.value = null
})

watch(showSignInDialog, (newVal) => {
  if (!newVal) {
    if (loadingItem.value === 'createUser') {
      loadingItem.value = ''
      isAdmin.value = false
      loadingItem.value = ''
      adminEmail.value = ''
      adminPassword.value = ''
    }
  }
})

onAuthStateChanged(auth, (user) => {
  if (user === null && !showSignInDialog.value) {
    window.location.reload()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(HeaderComponent, {
              title: 'Settings',
              "show-trailing-btn": false
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_expansion_panels, {
                modelValue: panel.value,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((panel).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel, {
                    title: "Change Password",
                    class: "rounded-xl",
                    expand: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _cache[15] || (_cache[15] = _createTextVNode(_toDisplayString('Change Password') + " ", -1)),
                              (loadingItem.value === 'changePassword')
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    color: "primary",
                                    indeterminate: ""
                                  }))
                                : (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    onClick: changePassword,
                                    color: "primary",
                                    variant: "tonal",
                                    disabled: !isValidPassword.value || newPassword.value !== confirmPassword.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                            ]),
                            _createVNode(_component_v_text_field, {
                              class: "mt-4",
                              modelValue: newPassword.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newPassword).value = $event)),
                              type: 'password',
                              label: 'New Password',
                              "prepend-inner-icon": 'mdi-key',
                              color: "primary",
                              clearable: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: confirmPassword.value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((confirmPassword).value = $event)),
                              type: 'password',
                              label: 'Confirm Password',
                              "prepend-inner-icon": 'mdi-key',
                              color: "primary",
                              clearable: ""
                            }, null, 8, ["modelValue"]),
                            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-caption" }, _toDisplayString('Password must be at least 8 characters long and contain uppercase and lowercase letters, numbers, and special characters.'), -1))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panel, {
                    title: "Create Account",
                    class: "rounded-xl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _cache[17] || (_cache[17] = _createTextVNode(_toDisplayString('Create Account') + " ", -1)),
                              (loadingItem.value === 'createUser')
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    color: "primary",
                                    indeterminate: ""
                                  }))
                                : (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    onClick: createUser,
                                    color: "primary",
                                    variant: "tonal",
                                    disabled: !isValidPasswordToCreate.value || passwordToCreate.value !== confirmPasswordToCreate.value || email.value === '' || !email.value.includes('@')
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                            ]),
                            _createVNode(_component_v_text_field, {
                              class: "mt-4",
                              modelValue: email.value,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                              type: 'email',
                              label: 'E-Mail',
                              "prepend-inner-icon": 'mdi-email',
                              color: "primary",
                              clearable: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: passwordToCreate.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((passwordToCreate).value = $event)),
                              type: 'password',
                              label: 'Password',
                              "prepend-inner-icon": 'mdi-key',
                              color: "primary",
                              clearable: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: confirmPasswordToCreate.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((confirmPasswordToCreate).value = $event)),
                              type: 'password',
                              label: 'Confirm Password',
                              "prepend-inner-icon": 'mdi-key',
                              color: "primary",
                              clearable: ""
                            }, null, 8, ["modelValue"]),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-caption" }, _toDisplayString('Password must be at least 8 characters long and contain uppercase and lowercase letters, numbers, and special characters.'), -1)),
                            _createVNode(_component_v_checkbox, {
                              modelValue: isAdmin.value,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isAdmin).value = $event)),
                              label: "Admin",
                              color: "primary",
                              "hide-details": ""
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_8, [
                              _cache[18] || (_cache[18] = _createTextVNode(_toDisplayString('Granting Admin rights allows you to write posts or make changes to the site using the account you created.\nThis task requires an administrator account.') + " ", -1)),
                              _createVNode(_component_v_btn, { variant: "text" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "fa-solid fa-circle-info",
                                    onClick: _cache[6] || (_cache[6] = ($event: any) => (showUserTypeDescriptionWindow.value = true))
                                  })
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panel, {
                    title: "Withdraw",
                    class: "rounded-xl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _cache[20] || (_cache[20] = _createTextVNode(_toDisplayString('Withdraw') + " ", -1)),
                              (loadingItem.value === 'withdraw')
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    color: "primary",
                                    indeterminate: ""
                                  }))
                                : (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    onClick: withdraw,
                                    color: "primary",
                                    variant: "tonal"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-arrow-right" })
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-caption" }, _toDisplayString('Withdrawing will prevent you from signing in anymore and cannot be undone.'), -1))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_dialog, {
                        modelValue: showUserTypeDescriptionWindow.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showUserTypeDescriptionWindow).value = $event)),
                        style: { backdropFilter: 'blur(5px)' }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card, { class: "pa-5" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card_title, {
                                class: "rounded-xl",
                                style: {"word-break":"break-word","white-space":"pre-wrap","position":"sticky","top":"0","background-color":"transparent","z-index":"1000"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, [
                                    _cache[22] || (_cache[22] = _createElementVNode("div", {
                                      class: "rounded-xl pa-2",
                                      style: {"max-width":"70%","word-break":"break-word","white-space":"pre-wrap","backdrop-filter":"blur(5px)"}
                                    }, " Site Permissions by User Type ", -1)),
                                    _createVNode(_component_v_btn, {
                                      color: "red",
                                      style: {"margin-left":"16px","flex-shrink":"0"},
                                      variant: "tonal",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (showUserTypeDescriptionWindow.value = false))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_card_text, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_table, null, {
                                    default: _withCtx(() => [
                                      _cache[23] || (_cache[23] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", { class: "text-left" }, " Feature "),
                                          _createElementVNode("th", { class: "text-left" }, " Administrator "),
                                          _createElementVNode("th", { class: "text-left" }, " Standard User "),
                                          _createElementVNode("th", { class: "text-left" }, " Guest(Non-Signed In) ")
                                        ])
                                      ], -1)),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featuresByUserType.value, (feature) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: feature.feature
                                          }, [
                                            _createElementVNode("td", null, _toDisplayString(feature.feature), 1),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_font_awesome_icon, {
                                                icon: feature.admin ? 'fa-solid fa-check' : 'fa-solid fa-xmark',
                                                color: feature.admin ? 'green' : 'red'
                                              }, null, 8, ["icon", "color"])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_font_awesome_icon, {
                                                icon: feature.standard ? 'fa-solid fa-check' : 'fa-solid fa-xmark',
                                                color: feature.standard ? 'green' : 'red'
                                              }, null, 8, ["icon", "color"])
                                            ]),
                                            _createElementVNode("td", null, [
                                              _createVNode(_component_font_awesome_icon, {
                                                icon: feature.guest ? 'fa-solid fa-check' : 'fa-solid fa-xmark',
                                                color: feature.guest ? 'green' : 'red'
                                              }, null, 8, ["icon", "color"])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1,
                                    __: [23]
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_expansion_panel, {
                    title: "Banner",
                    class: "rounded-xl"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_expansion_panel_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _cache[24] || (_cache[24] = _createTextVNode(_toDisplayString('Change Banner Content') + " ", -1)),
                              (loadingItem.value === 'banner')
                                ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                    key: 0,
                                    color: "primary",
                                    indeterminate: ""
                                  }))
                                : (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    color: "primary",
                                    variant: "tonal",
                                    onClick: changeBanner,
                                    disabled: selectedBanner.value === null
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                            ]),
                            _createVNode(_component_v_radio_group, {
                              modelValue: bannerType.value,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((bannerType).value = $event)),
                              inline: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_radio, {
                                  label: "Video",
                                  value: "Video",
                                  color: "primary"
                                }),
                                _createVNode(_component_v_radio, {
                                  label: "Image",
                                  value: "Image",
                                  color: "primary"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_v_file_input, {
                              modelValue: selectedBanner.value,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedBanner).value = $event)),
                              "prepend-icon": bannerType.value === 'Video' ? 'mdi-video' : 'mdi-image',
                              label: 'Load File',
                              accept: bannerType.value === 'Video' ? 'video/*' : 'image/*',
                              variant: "solo-filled"
                            }, null, 8, ["modelValue", "prepend-icon", "accept"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createVNode(_component_v_dialog, {
          modelValue: showSignInDialog.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((showSignInDialog).value = $event)),
          style: { backdropFilter: 'blur(5px)' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, {
                  class: "rounded-xl",
                  style: {"word-break":"break-word","white-space":"pre-wrap","position":"sticky","top":"0","background-color":"transparent","z-index":"1000"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-sign-in",
                          style: {"margin-right":"8px"}
                        }),
                        _cache[25] || (_cache[25] = _createTextVNode(" " + _toDisplayString('Sign In'), -1))
                      ]),
                      _createVNode(_component_v_btn, {
                        color: "red",
                        style: {"margin-left":"16px","flex-shrink":"0"},
                        variant: "tonal",
                        onClick: closeSignInDialog
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-xmark" })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_subtitle, null, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode(_toDisplayString('Sign in as an administrator to elevate the privileges of the user you just created.'), -1)
                  ])),
                  _: 1,
                  __: [26]
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      class: "mt-4",
                      modelValue: adminEmail.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((adminEmail).value = $event)),
                      type: 'email',
                      label: 'E-Mail',
                      "prepend-inner-icon": 'mdi-email',
                      color: "primary",
                      clearable: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: adminPassword.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((adminPassword).value = $event)),
                      type: 'password',
                      label: 'Password',
                      "prepend-inner-icon": 'mdi-key',
                      color: "primary",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    (isLoggingIn.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          color: "primary",
                          indeterminate: ""
                        }))
                      : (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          disabled: adminEmail.value === '' || adminPassword.value === '',
                          onClick: signIn,
                          variant: "tonal",
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-check" })
                          ]),
                          _: 1
                        }, 8, ["disabled"]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})